import React from 'react';

import { CellProps, Column } from 'react-table';
import { ClassUsageReportItem } from 'types/generated/models/ClassUsageReportItem';
import { getDayNameFromWeekdayNumber } from 'utils/weekdays';

import ChangeCell from './ChangeCell';
import ChangeHeader from './ChangeHeader';
import UtilizationRateHeader from './UtilizationRateHeader';

const columns = [
  {
    Header: 'Class',
    accessor: 'classTypeName' as const,
  },
  {
    Header: 'Day',
    accessor: 'weekday' as const,
    Cell: ({ value }: CellProps<ClassUsageReportItem>) =>
      value === 'All' ? value : getDayNameFromWeekdayNumber(value),
  },
  {
    Header: 'Start Time',
    accessor: 'startTime' as const,
  },
  {
    Header: 'Coach',
    accessor: 'coachFullName' as const,
  },
  {
    Header: 'Sessions',
    accessor: 'totalSessions' as const,
  },
  {
    Header: 'Available Spots',
    accessor: 'availableSpots' as const,
  },
  {
    Header: 'Reserved Spots',
    accessor: 'reservedSpots' as const,
  },
  {
    Header: 'Attended',
    accessor: 'attended' as const,
  },
  {
    Header: 'Avg Attendance',
    accessor: 'averageAttendance' as const,
    Cell: ({ value }: CellProps<ClassUsageReportItem>) => Math.ceil(value),
  },
  {
    Header: 'No Shows',
    accessor: 'noShows' as const,
  },
  {
    Header: 'Late Cancels',
    accessor: 'lateCancels' as const,
  },
  {
    Header: <UtilizationRateHeader />,
    accessor: 'utilizationRate' as const,
    Cell: ({ value }: CellProps<ClassUsageReportItem>) => (
      <div style={{ textAlign: 'center' }}>{`${(value * 100).toFixed(1)}%`}</div>
    ),
  },
  {
    Header: <ChangeHeader />,
    accessor: 'changePercentage' as const,
    Cell: ({ value }: CellProps<ClassUsageReportItem>) => <ChangeCell change={value} />,
  },
] satisfies Column<ClassUsageReportItem>[];

export default columns;
